export const buildingInclude = 'buildings.buildingProductStates';
export const condoSearchQueryBase = {
	_limit: 25,
};
